export default abstract class FieldValue {
    protected constructor(readonly label: string, readonly id: string) {}
}
